module.exports = __webpack_public_path__ + "img/TeamComic_057.710f4da2.png";